let bsParams = {        /* 音像制品 基本情况表 */

    publishName: '',     // 出版单位名称
    usccNum: '',     // 统一社会信用代码
    usccOrgName: '',     // 营业执照上“名称”
    usccType: '',     // 营业执照类型
    residence: '',     // 住所
    faren: '',
    yyzzZczb: '',     // 营业执照注册资本
    clDate: '',     // 成立日期

    areaDate: '',

    startYyDate: '',     // startYyDate
    endYyDate: '',     // endYyDate
    yyfw: '',     // 经营范围
    djDate: '',     // 登记日期
    usccCode: '',     // 证照编号
    yyzzId: '',     // 营业执照附件ID

    nature: '',     // 企业性质（选择项）
    otherNature: '',     // 企业性质（其他）
    isIndependentLP: '',     // 是否独立法人（选择项）
    unitType: '',     // 独立法人单位类型（选择项）
    independentLPSituation: '',     // 独立法人隶属关系（选择项）
    nonIndependentLPSituation: '',     // 非独立法人隶属关系（选择项）
    publishAddr: '',     // 出版单位地址
    publishPostalcode: '',     // 出版单位邮政编码
    publishLinkman: '',     // 出版单位联系人
    publishTel: '',     // 出版单位联系电话
    publishPhone: '',     // 出版单位联系人手机号
    workers: '',     // 职工总数
    businessWorkers: '',     // 从事（电子/音像）业务人员数
    otherWorkers: '',     // 其他人员数
    registeredCapital: '',     // 注册资本（万元）
    totalAssets: '',     // 资产总额（万元）
    totalLiabilities: '',     // 负债总额（万元）
    remark: '',     // 备注


    id: '',     // id
    publishId: '',     // 出版单位ID
    publishMaterialId: '',     // 当前年度，出版单位填写资料表，资料表Id
    updatedAt: '',//申报时间
}


let mobelPhone = (rule, val, callback) => {      // 手机验证
    var pattern = /^1[0-9]{10}$/;
    if (val == '') {
        callback(new Error('请输入手机号'));
    } else if (!pattern.test(val)) {
        callback(new Error('手机号格式错误！'));
    } else {
        callback();
    }
};

let zipCode = (rule, val, callback) => {      // 邮编验证
    var pattern = /(^[0-9]{6})$/;
    if (val == '') {
        callback(new Error('请输入单位邮编'));
    } else if (!pattern.test(val)) {
        callback(new Error('邮编格式错误！'));
    } else {
        callback();
    }
};

let homePhone = (rule, val, callback) => {      //固话验证
    var pattern = /(^(0\d{2,3})?-?\d{7,8}$)$/;
    if (val == '') {
        callback(new Error('请输入电话'));
    } else if (!pattern.test(val)) {
        callback(new Error('电话格式错误！'));
    } else {
        callback();
    }
};

let paramsRule = {

    publishName: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 出版单位名称
    usccNum: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 统一社会信用代码
    usccOrgName: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 营业执照上“名称”
    usccType: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 营业执照类型
    residence: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 住所
    faren: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],
    yyzzZczb: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 营业执照注册资本
    clDate: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 成立日期
    areaDate: [
        { required: true, message: '请选择', trigger: 'change' },
    ],
    startYyDate: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // startYyDate
    endYyDate: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // endYyDate
    yyfw: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 1000, message: '填写内容过长！', trigger: 'blur' }
    ],     // 经营范围
    djDate: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 登记日期
    usccCode: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 证照编号
    yyzzId: [
        { required: true, message: '请上传！', trigger: 'change' }
    ],     // 证照编,     // 营业执照附件ID

    nature: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 企业性质（选择项）
    otherNature: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],
    isIndependentLP: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 是否独立法人（选择项）
    unitType: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 独立法人单位类型（选择项）
    independentLPSituation: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 独立法人隶属关系（选择项）
    nonIndependentLPSituation: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 非独立法人隶属关系（选择项）
    publishAddr: [
        { required: true, message: '请选择', trigger: 'change' },
    ],     // 出版单位地址
    publishPostalcode: [
        { validator: zipCode, trigger: 'blur' },
    ],     // 出版单位邮政编码
    publishLinkman: [
        { required: true, message: '不能为空！', trigger: 'blur' },
        { max: 127, message: '填写内容过长！', trigger: 'blur' }
    ],     // 出版单位联系人
    publishTel: [
        { validator: homePhone, trigger: 'blur' },
    ],     // 出版单位联系电话
    publishPhone: [
        { validator: mobelPhone, trigger: 'blur' },
    ],     // 出版单位联系人手机号

    remark: [
        { max: 1000, message: '填写内容过长！', trigger: 'blur' }
    ],

    workers: '',     // 职工总数
    businessWorkers: '',     // 从事（电子/音像）业务人员数
    otherWorkers: '',     // 其他人员数
    registeredCapital: '',     // 注册资本（万元）
    totalAssets: '',     // 资产总额（万元）
    totalLiabilities: '',     // 负债总额（万元）


}

export { bsParams, paramsRule };



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt1.js